export function setLocalData(key, value) {
  try {
    if (typeof value !== "string") {
      value = JSON.stringify(value);
      localStorage.setItem(key, value);
    }
  } catch (error) {
    console.log(error);
  }
}

export function getLocalData(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.log(error);
  }
}
